"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormService = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const store_1 = require("../store");
const index_1 = require("./index");
class FormService {
    constructor() {
        this.__priority = 100;
    }
    /**
     * Saves a form.
     *
     * @returns New, saved, form.
     */
    save(form) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = index_1.Services.Department.rest;
            const formJSON = core_shared_1.IkeModel.Form.write(form);
            const newFormJSON = yield rest.save(rest.Objects.Form, formJSON);
            const savedForm = core_shared_1.IkeModel.Form.read(newFormJSON);
            // Saving a form creates a new version document in the database, which gets a fresh _created_at.
            // Preserve the original createdAt for existing forms so the UI shows when the form was first created.
            if (form.id != null && form.createdAt != null) {
                savedForm.createdAt = form.createdAt;
            }
            return savedForm;
        });
    }
    /**
     * Archives a form, hiding it from active form lists.
     *
     * @returns Revision of archived form.
     */
    archive(uuid) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = index_1.Services.Department.rest;
            const startTime = Date.now();
            const result = yield rest.Form.delete({ uuid });
            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Form, 'FORM_ARCHIVE', `uuid: ${uuid}`, Date.now() - startTime);
            store_1.AppStore.FormSummary.refresh();
            return result.results.revision;
        });
    }
    /**
     * Unarchives a form, restoring it to the active form list.
     *
     * @returns Revision of restored form.
     */
    unarchive(uuid) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = index_1.Services.Department.rest;
            const startTime = Date.now();
            const result = yield rest.Form.restore({ uuid });
            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Form, 'FORM_UNARCHIVE', `uuid: ${uuid}`, Date.now() - startTime);
            store_1.AppStore.FormSummary.refresh();
            return result.results.revision;
        });
    }
    /**
     * Shares a form with another department of the same organization.
     *
     * @returns New form revision.
     */
    share(revision, toDepartmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = index_1.Services.Department.rest;
            const startTime = Date.now();
            const result = yield rest.Form.share({ revision, toDepartmentId });
            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Form, 'FORM_SHARE', `revision:${revision} -> department:${toDepartmentId}`, Date.now() - startTime);
            return result.results.revision;
        });
    }
    copy(formId, toDepartmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = index_1.Services.Department.rest;
            const startTime = Date.now();
            const result = yield rest.Form.copy({ formId, toDepartmentId });
            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Form, 'FORM_COPY', toDepartmentId ? `id:${formId} -> department:${toDepartmentId}` : `id:${formId}`, Date.now() - startTime);
            return result.results.formId;
        });
    }
}
exports.FormService = FormService;
//# sourceMappingURL=form.service.js.map